// extracted by mini-css-extract-plugin
export var actionText = "_ma-4";
export var container = "_ma-0";
export var leftSection = "_ma-1";
export var rightSection = "_ma-2";
export var settingsButton = "_ma-6";
export var settingsIcon = "_ma-7";
export var shortcut = "_ma-5";
export var shortcutGroup = "_ma-3";